module.exports = __webpack_public_path__ + "static/media/usdc.a2b9c747.svg";